import type { LinkItem } from '../../doc/schema';

function hostOf(url: string): string {
  try {
    return new URL(url).host.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** Website card: preview image, title, description, host. Double-click opens the link. */
export function LinkBody({ item }: { item: LinkItem }) {
  const { url, title, description, image, site, status } = item.props;
  return (
    <div className={`link-card link-${status}`}>
      {image ? (
        <div className="link-image" style={{ backgroundImage: `url("${image.replace(/"/g, '%22')}")` }} />
      ) : (
        <div className="link-image link-image-empty">{status === 'loading' ? '…' : hostOf(url).slice(0, 1).toUpperCase()}</div>
      )}
      <div className="link-body">
        <div className="link-title">{title || url}</div>
        {description && <div className="link-desc">{description}</div>}
        <div className="link-site">
          {site || hostOf(url)}
          {status === 'loading' && ' · loading preview'}
          {status === 'error' && ' · no preview'}
        </div>
      </div>
    </div>
  );
}
